// This file was autogenerated from running npm run sync-files.
// DO NOT EDIT THIS FILE DIRECTLY.
// Edit the source file below and then run `npm run sync-files`
// Source: ui/oopsyraidsy/data/04-sb/trial/shinryu-ex.ts

import NetRegexes from '../../../../../resources/netregexes';
import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';
import { playerDamageFields } from '../../../oopsy_common';

// TODO: Hellfire (C437) without Fire Resistance Up (208).
// TODO: Levinbolt (C447) while having Lightning Resistance Down II (4EC).
// TODO: Hypernova (C445) while not having Deep Freeze (4E6) or Fire Resistance Up (208).
// TODO: Doom (D2) expiring.

export type Data = OopsyData;

// Shinryu Unreal
const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.ShinryusDomainUnreal,
  damageWarn: {
    'ShinryuUn Burning Chains': 'C45E', // not breaking chains fast enough
    'ShinryuUn Icicle Icicle Impact': 'C44B', // icicles landing
    'ShinryuUn Icicle Spikesicle': 'C44C', // icicle dash
    'ShinryuUn Tail Slap': 'C43E', // tail add appearing
    'ShinryuUn Dragonfist': 'C46D', // giant punchy circle in the center.
    'ShinryuUn Gyre Charge': 'C45F', // phase 1 large dive attack
    'ShinryuUn Ginryu Fireball': 'C467', // targeted circle during add phase
    'ShinryuUn Hakkinryu Blazing Trail': 'C465', // wide line during add phase
    'ShinryuUn Tail Spit': 'BC2D', // blue puck during knockback
    'ShinryuUn Aetherial Ray': 'C474', // lasers while running along the tail
    'ShinryuUn Levinbolt': 'C486', // baited lightning during final phase
    'ShinryuUn Wormwail': 'C475', // donut attack
    'ShinryuUn Benighting Breath': 'C477', // 90 degree conal attack
  },
  shareWarn: {
    'ShinryuUn Levinbolt Spread': 'C446', // untelegraphed lightning spread
    'ShinryuUn Earth Breath': 'C449', // earthshaker-esque conal attacks
  },
  soloWarn: {
    'ShinryuUn Hypernova': 'C445', // stack in puddle damage
    'ShinryuUn Atomic Ray': 'C47A', // pair stack markers in final phase
  },
  triggers: [
    {
      // Icy floor attack.
      id: 'ShinryuUn Diamond Dust',
      type: 'GainsEffect',
      // Thin Ice
      netRegex: NetRegexes.gainsEffect({ effectId: '38F' }),
      deathReason: (_data, matches) => {
        return {
          id: matches.targetId,
          name: matches.target,
          text: {
            en: 'Slid off!',
            de: 'Runter gerutscht!',
            fr: 'A glissé(e) !',
            ja: '滑った',
            cn: '滑落',
            ko: '미끄러짐',
            tc: '滑落',
          },
        };
      },
    },
    {
      id: 'ShinryuUn Tidal Wave',
      type: 'Ability',
      netRegex: NetRegexes.ability({ id: 'C436', ...playerDamageFields }),
      deathReason: (_data, matches) => {
        return {
          id: matches.targetId,
          name: matches.target,
          text: {
            en: 'Pushed off!',
            de: 'Runter geschubst!',
            fr: 'Repoussé(e) !',
            ja: '落ちた',
            cn: '击退坠落',
            ko: '넉백됨',
            tc: '擊退墜落',
          },
        };
      },
    },
    {
      // Knockback from center.
      id: 'ShinryuUn Aerial Blast',
      type: 'Ability',
      netRegex: NetRegexes.ability({ id: 'C43B', ...playerDamageFields }),
      deathReason: (_data, matches) => {
        return {
          id: matches.targetId,
          name: matches.target,
          text: {
            en: 'Pushed off!',
            de: 'Runter geschubst!',
            fr: 'Repoussé(e) !',
            ja: '落ちた',
            cn: '击退坠落',
            ko: '넉백됨',
            tc: '擊退墜落',
          },
        };
      },
    },
  ],
};

export default triggerSet;
